import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as history } from '@styles/icons/history.svg';
import React from 'react';

export const GasIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={history} viewBox={'0 0 24 24'} />
);

export default GasIcon;
